import type { MemoryDictionary } from '../memoryContract'

const memory = {
  page: {
    eyebrow: '企业营销记忆',
    title: '企业营销记忆',
    intro: '这里不是资料仓库。它呈现领航者目前怎样理解这家企业，并让诊断、行动、发布与复盘从同一份认知继续。',
    updated: '企业记忆已更新',
    lastUpdated: '上次更新 · {date}',
    reportIssue: '这里有一处不对',
  },
  tabs: {
    overview: '当前理解',
    cognition: '企业认知',
    knowledge: '知道什么',
    strategy: '怎么做',
    identity: '它是谁',
    connections: '如何相连',
  },
  cognition: {
    title: '领航者怎样认识这家企业', body: '随时回看已确认的初始画像和完整企业研究。它们是当前项目长期保留的认知成果，不是一次性接入页面。', assets: '份认知成果',
    loading: '正在读取企业认知', loadingBody: '正在取回当前项目已确认的企业画像与企业研究。', error: '暂时无法读取企业认知', errorBody: '其它企业记忆没有改变；可以重新读取这两份已保存成果。',
    profileEyebrow: '初始画像', profileTitle: '已确认的企业画像', researchEyebrow: '企业研究', researchTitle: '完整研究综合', notCreated: '尚未形成', completed: '已完成', confirmedAt: '确认于 {date}', generatedAt: '生成于 {date}', profileEmpty: '当前项目还没有已确认的初始画像。', researchEmpty: '当前项目还没有完成企业研究。', summary: '研究结论', facts: '{count} 条事实', hypotheses: '{count} 条假设', unknowns: '{count} 项未知', candidates: '{count} 个候选', findings: '展开 {count} 条关键发现', evidence: '查看事实、假设与未知', knownFacts: '已知事实', hypothesisTitle: '待验证假设', unknownTitle: '未知与冲突',
    fields: { brand_identity: '品牌身份', domain_footprint: '官网及相关域名', product_lines: '主要产品或产品线', markets_languages: '目标市场与语言', buyer_types: '典型客户或买家', competitors: '初始竞品参考', public_content_foundation: '公开内容基础', website_shape: '官网现状', company_type: '初始企业类型' },
  },
  common: {
    confirmed: '已确认',
    awaitingConfirmation: '等待确认',
    awaitingEvidence: '待更多证据',
    continueObserving: '继续观察',
    inProgress: '进行中',
    connected: '已连接',
    view: '查看',
    close: '关闭',
    cancel: '取消',
    retry: '重试',
    later: '稍后处理',
  },
  contentLanguage: {
    original: '原文 · {language}',
    unchangedHint: '企业事实、品牌原文与证据原句保持原语言。',
  },
  overview: {
    currentUnderstanding: '领航者目前这样理解 {company} · 等待你确认',
    viewBrandDirection: '查看品牌意志',
    suggestCorrection: '提出纠正',
    sharedUnderstanding: '让每一项营销工作从同一份理解继续',
    map: {
      knowledge: '知道什么',
      knowledgeHint: '事实与市场',
      strategy: '怎么做',
      strategyHint: '策略与实施',
      identity: '它是谁',
      identityHint: '价值与取舍',
      connections: '如何相连',
      connectionsHint: '行动与结果',
    },
    cards: {
      knowledgeTitle: '知道什么',
      knowledgeBody: '查看已经确认的事实、市场怎样回应，以及仍需补充的认知。',
      strategyTitle: '怎么做',
      strategyBody: '查看本阶段的营销方向、执行进度，以及下一步建议。',
      identityTitle: '它是谁',
      identityBody: '确认市场应该记住的核心表达、价值支柱与模块角色。',
      connectionsTitle: '如何相连',
      connectionsBody: '看清每项成果从何而来、带来什么，以及怎样改变下一步。',
      enter: '进入查看 →',
      confirmedModules: '{count} 条已确认',
      liveOutcomes: '{count} 项成果',
    },
    learning: {
      eyebrow: '最近学习',
      title: '最近学会了什么',
      body: '领航者会记住哪些表达真正有效、哪些方向仍需验证，让下一次工作建立在这一次的结果之上。',
      adopted: '已经使用',
      observing: '继续验证',
    },
  },
  knowledge: {
    eyebrow: '知道什么',
    title: '已经确认什么，还需要了解什么',
    body: '在这里查看产品事实、市场反馈与仍待补充的信息，随时纠正领航者对企业的理解。',
    confirmedFacts: '{count} 条已确认公开事实',
    search: '搜索事实、市场观察或缺口',
    filter: {
      all: '全部类型',
      facts: '已确认事实',
      market: '市场观察',
      gaps: '知识缺口',
      outcomes: '生产结果',
    },
    addMaterial: '补充资料',
    category: {
      positioning: '产品定位',
      specification: '产品规格',
      platforms: '平台与版本',
      marketSignal: '市场观察',
      gap: '知识缺口',
      outcome: '生产结果',
    },
    source: {
      official: '官网公开事实',
      aiMonitoring: 'AI 答案监测',
      awaitingSamples: '等待更多样本',
      humanReview: '人工评审',
    },
    action: {
      viewBasis: '查看依据',
      viewFacts: '查看 {count} 条原始事实',
      viewAnswer: '查看这次回答',
      viewMissing: '查看还缺什么',
      viewLearning: '查看学到了什么',
    },
    status: {
      confirmed: '已确认',
      moreEvidence: '待更多证据',
      passedReviews: '{count} 次通过',
    },
    noMatchTitle: '没有找到匹配的记忆',
    noMatchBody: '换一个关键词，或切回全部类型。',
  },
  strategy: {
    eyebrow: '本阶段计划',
    title: '本阶段准备怎样推进营销',
    body: '这里把当前目标、正在执行的工作、需要你参与的事项和下一步建议放在一起。',
    responsibilitySummary: '领航者负责 {owned} 项 / 需要协作 {collaborative} 项',
    directionAwaiting: '本阶段营销方向 · 等待你确认',
    emptyTitle: '本阶段方向还没有确认',
    emptyBody: '领航者不会把一条执行记录冒充成策略。先确认阶段目标与营销方向。',
    workEmptyTitle: '还没有安排由领航者推进的工作',
    workEmptyBody: '策略确认并形成实施计划后，工作会出现在这里。',
    guidanceEmptyTitle: '目前没有需要团队配合的指导事项',
    guidanceEmptyBody: '只有当策略需要超出领航者执行边界的工作时，才会在这里给出建议。',
    brief: {
      goal: '这阶段要做到',
      message: '希望市场记住',
      reviewWhen: '什么时候复盘',
    },
    journey: {
      goal: '明确目标',
      goalHint: '希望影响谁、改变什么',
      theme: '确定主题',
      themeHint: '让所有内容表达同一个重点',
      work: '推进工作',
      workHint: '内容、页面、发布与协作',
      feedback: '观察反馈',
      feedbackHint: 'AI 答案、线索和用户声音',
      next: '决定下一步',
      nextHint: '继续、调整或更换方向',
    },
    navigatorLed: {
      eyebrow: '领航者负责',
      title: '领航者将为你完成',
      body: '以下工作由领航者从方向梳理持续推进到上线与复盘。',
      count: '{count} 项工作',
      positioningTitle: '确定本阶段的主张与竞争位置',
      positioningBody: '从买家真正关心的问题出发，讲清核心价值、模块作用与选择理由。',
      contentTitle: '把策略变成可以上线的内容',
      contentBody: '持续制作产品页、常见问题、买家指南、对比内容和多语言页面。',
      machineTitle: '让官网和 AI 同时读懂新内容',
      machineBody: '在既有官网中补充入口、页面关系与机器可读信息。',
      publishTitle: '发布，并确认每项成果正常可见',
      publishBody: '根据你的授权安排人工、协作或自动发布，并检查页面与搜索入口。',
      reviewTitle: '跟踪市场反馈，准备下一阶段',
      reviewBody: '结合 AI 答案、线索与用户反馈，判断哪些方向继续、哪些需要调整。',
      completed: '已完成',
      pagesOnline: '{count} 页在线',
      ongoing: '持续更新',
      connected: '已连接',
      monitoring: '持续观察',
    },
    collaboration: {
      eyebrow: '与你的团队协作',
      title: '这些工作需要你或团队参与',
      body: '领航者会准备方向与内容，你决定何时启动，并由相应团队完成。',
      socialTitle: '{channels} 发声',
      socialBody: '领航者准备主题、节奏与内容改编，由你确认并发布。',
      socialStatus: '共同完成',
      mediaTitle: '付费媒介',
      mediaBody: '领航者提供受众、议题与素材建议，由你的媒介团队安排预算和投放。',
      mediaStatus: '需要账户',
      prTitle: '公关、活动与合作',
      prBody: '领航者建议议题、时机与合作方向，由你或合作团队完成对外沟通。',
      prStatus: '需要团队',
    },
    results: {
      eyebrow: '市场怎样回应',
      title: '下一步怎么走，由真实反馈决定',
      body: '领航者同时观察市场怎样谈论你、什么样的客户正在靠近，以及用户为什么选择或犹豫。',
      aiTitle: 'AI 正在怎样谈论你',
      aiBody: '持续观察品牌是否被提及、如何被推荐、与谁一起出现，以及引用了哪些内容。',
      aiAction: '持续监测 · 查看最新评测 →',
      leadsTitle: '什么样的客户正在靠近',
      leadsBody: '结合线索来源、买家问题与后续进展，判断营销是否带来了真正合适的人。',
      leadsAction: '线索已连接 · 查看线索变化 →',
      surveyTitle: '客户为什么选择或犹豫',
      surveyBody: '直接询问哪些表达建立了信任、哪里仍不清楚，以及最终决定受什么影响。',
      surveyAction: '可以随时发起 · 创建用户问卷 →',
    },
    recommendation: {
      continue: '建议继续',
      adjust: '建议调整',
      schedule: '等待安排',
    },
    methods: {
      eyebrow: '领航者学到的经验',
      title: '领航者已经学会的工作原则',
      body: '这些经验来自真实工作与人工判断，并会持续影响下一次内容和策略。',
      count: '{active} 条已经使用 / {observing} 条继续验证',
      search: '搜索原则',
      filterAll: '全部状态',
      filterActive: '已经使用',
      filterObserving: '继续验证',
      expression: '表达原则',
      competition: '竞争原则',
      promise: '承诺原则',
      inUse: '已经使用',
      validating: '继续验证',
      impact: '查看它如何影响工作',
      scope: '查看适用范围',
      validation: '查看还需验证什么',
      emptyBody: '目前还没有证据足够的工作方法可以显示。',
    },
  },
  identity: {
    eyebrow: '希望市场怎样记住你',
    title: '{company} 希望被怎样理解',
    body: '在这里确认市场首先应该记住什么，以及企业的产品与能力怎样共同支撑这份认知。',
    confirmedModules: '{count} 条模块表达已确认',
    coreAwaiting: '核心表达 · 等待你确认',
    confirm: '确认这条表达',
    revise: '提出修订',
    usage: '查看它将用在哪里',
    awaitingDecision: '等待你的决定',
    notActive: '核心表达尚未生效',
    afterConfirm: '确认后，领航者会用它统一官网、内容与后续营销行动。',
    pillarAwaiting: '请确认',
    modulesEyebrow: '已确认的模块表达',
    modulesTitle: '产品与能力如何共同支撑核心价值',
    modulesCount: '{count} 条已确认',
    moduleAction: '已确认 · 查看完整表达',
    noCoreTitle: '核心表达还没有形成',
    noCoreBody: '领航者需要已确认的企业资料与人的意志，才能提出核心表达。',
    noModulesBody: '已确认的产品与能力表达会显示在这里。',
  },
  connections: {
    eyebrow: '从一个阶段走向下一个阶段',
    title: '每一次行动，都让下一次更准确',
    body: '你可以看到上一轮做了什么、市场怎样回应，以及这些结果如何改变下一步。',
    onlineOutcomes: '{count} 项在线成果',
    journeyEyebrow: '一条连续的行动',
    journeyTitle: '从判断到实施，再让结果改变下一阶段',
    steps: {
      stage: '识别阶段',
      stageHint: '业务目标、买家问题与认知缺口',
      strategy: '制定策略',
      strategyHint: '阶段主题、竞争位置与成功判据',
      work: '推进工作',
      workHint: '组织内容、页面、发布与协作任务',
      results: '接收结果',
      resultsHint: 'AI 答案、线索池与用户问卷',
      next: '下一阶段',
      nextHint: '维持、调整或更换策略并沉淀经验',
    },
    note: '领航者会同时参考 AI 答案、线索与用户反馈。有效方向会被延续，没有带来结果的尝试也会被记住，让下一阶段少走弯路。',
    recentTitle: '最近一次完整行动',
    recentBody: '从发现买家问题，到双语指南上线，再到把结果用于下一轮内容。',
    noRecentBody: '目前还没有记录完整的行动血脉。',
    viewProcess: '查看完整过程',
    accumulatedTitle: '领航者已经积累了什么',
    accumulatedBody: '这些记录帮助后续工作从已有经验继续，而不是每次重新开始。',
    stats: {
      live: '已上线成果',
      attempts: '已记录的尝试',
      judgments: '经验判断',
      actions: '完整行动',
    },
  },
  airlockGap: {
    eyebrow: '来自 Airlock 发布',
    title: '补齐 Airlock 回答所需的企业依据',
    subject: '需要补充的主题',
    status: '当前状态',
    statusPending: '等待补充资料',
    statusQueued: '资料已提交 · 等待处理',
    statusSynced: '已同步 · 可以返回复测',
    flowLabel: '知识补齐流程',
    flow: {
      supply: '补充事实',
      classify: '资料分域',
      confirm: '确认知识',
      retest: '返回复测',
    },
    reason: {
      missing_knowledge: '已确认的企业资料里还没有这个问题的可靠答案。请补充原始依据，或写清准确的业务事实。',
      conflicting_knowledge: '现有资料对这个问题说法不一致。请补充当前有效的权威口径，并说明它取代了什么。',
      knowledge_not_public: '企业内部已有相关信息，但 Airlock 还不能公开使用。请补充可公开的表述，或返回选择安全收口。',
      knowledge_not_synced: '已确认知识还没有同步到这个 Airlock 的使用范围。请核对现有知识，或在这里补上缺失依据。',
      not_applicable_review: '这个事项仍需要业务判断。适用时请补充事实；不适用时请返回 Airlock 确认。',
    },
    queuedBody: '你补充的内容已经进入资料处理队列。只有它成为已确认知识并同步到当前 Airlock 后，发布缺口才会关闭。',
    addStatement: '补充事实说明',
    submitted: '事实说明已提交',
    reviewKnowledge: '查看现有知识',
    returnToAirlock: '返回 Airlock 发布',
    correctionTitle: '为这个 Airlock 缺口补充依据',
    correctionBody: '请写可核验的业务事实，并尽量说明来源。提交不会直接公开，也不会提前关闭缺口。',
    correctionLabel: '业务事实或依据',
    correctionPlaceholder: '例如：标准规格最低订购量为 500 件，依据为 2026 年现行销售政策……',
    correctionSubmit: '提交处理',
    queuedToast: '资料已收到；知识确认并同步前，Airlock 缺口仍保持打开。',
  },
  states: {
    loadingTitle: '正在汇合企业记忆',
    loadingBody: '领航者正在读取事实、策略、实施、结果与经验。尚未读到的内容不会显示为 0，也不会被当作不存在。',
    emptyEyebrow: '新企业',
    emptyTitle: '这家企业的记忆还没有开始',
    emptyBody: '先接入官网与资料。领航者会先做功课，只把真正需要你判断的部分带回来。',
    connectMaterial: '接入第一份资料',
    readWebsite: '先读取官网',
    errorEyebrow: '读取失败',
    errorTitle: '暂时无法读取企业记忆',
    errorBody: '已有记忆没有丢失，也不会被空白覆盖。你可以重新读取，或查看上一次可信快照。',
    retry: '重新读取',
    lastSnapshot: '查看上次可信快照',
    snapshotUnavailable: '当前会话没有可用的可信快照。',
    humanEyebrow: '需要你的决定',
    humanTitle: '领航者找到了不止一个成立的方向',
    humanBody: '它不会替你选择。请比较选项，并确认最符合企业意志的表达。',
    choose: '前往选择',
    later: '稍后处理',
    decisionDeferred: '这项决定仍在等待中，系统没有改变方向。',
  },
  detail: {
    eyebrow: '记忆详情',
    correct: '这里需要纠正',
    source: '查看来源',
    correctionTitle: '纠正领航者的理解',
    correctionBody: '你的纠正会成为新的输入，但不会静默覆盖已确认事实与原始来源。',
    correctionLabel: '你的纠正',
    correctionPlaceholder: '例如：买家首先选择我们的原因是长期可控，而不只是某个功能更方便……',
    cancel: '取消',
    submit: '提交纠正',
    submitting: '正在提交…',
    correctionQueued: '纠正已收到；完成分域后，才会进入企业记忆。',
    correctionFailed: '纠正暂时无法提交。',
    fields: {
      id: '记录 ID',
      locale: '原文语言',
      source: '来源',
      scope: '适用范围',
      confidence: '置信度',
      status: '状态',
      question: '买家问题',
      platform: '平台',
      output: '关联成果',
    },
  },
} satisfies MemoryDictionary

export default memory
